// DWA-3879 TODO: add key events for all icons and remove these linter comments

import React, { useState } from 'react'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

import ServiceContractModal from './ServiceContractModal'

import { useSessionContext } from 'hooks/SessionContext'

import { longDate } from 'helpers/formatters'

import { DeviceBase } from 'types/Device'

type Props = {
  customerName?: string
  device: DeviceBase
  className?: string
  displayIcon: boolean
}

const ServiceContractIcon = ({ customerName, device, className, displayIcon }: Props) => {
  const [displayServiceContractModal, setDisplayServiceContractModal] = useState(false)
  const { session: { isDealer, isAdmin } } = useSessionContext()

  let Icon = ''
  let tooltip = ''

  if (device.serviceContractStatus === 'None' || !device.serviceContractStatus) {
    Icon = '/img/service_contract_none.svg'
    tooltip = 'This device does not have a service contract.'
  } else if (device.serviceContractStatus === 'Active' && !device.serviceContractEndAt) {
    Icon = '/img/service_contract_active.svg'
    tooltip = 'This device has a service contract.'
  } else if (device.serviceContractStatus === 'Active' && device.serviceContractEndAt) {
    Icon = '/img/service_contract_active.svg'
    tooltip = `This device has a service contract that expires on ${longDate(device.serviceContractEndAt)}`
  } else if (device.serviceContractStatus === 'Expired') {
    Icon = '/img/service_contract_expired.svg'
    tooltip = `This device had a service contract that expired on ${longDate(device.serviceContractEndAt)}`
  }

  const toggleServiceContractModal = (updatedDevice) => {
    device.serviceContractNotes = updatedDevice.serviceContractNotes
    device.serviceContractStatus = updatedDevice.serviceContractStatus
    device.serviceContractStartAt = updatedDevice.serviceContractStartAt
    device.serviceContractEndAt = updatedDevice.serviceContractEndAt

    setDisplayServiceContractModal(!displayServiceContractModal)
  }

  return (
    <>
      <Tooltip className="serviceContract" title={tooltip}>
        <KeyboardAccessible onClick={() => toggleServiceContractModal(device)} >
          <S.Image className={className} displayIcon={displayIcon} alt={`${device.name}`} src={Icon} />
        </KeyboardAccessible >
      </Tooltip>
      {displayServiceContractModal && (isDealer || isAdmin) && <ServiceContractModal customerName={customerName} device={device} closeCallback={toggleServiceContractModal} />}
    </>
  )
}

export default ServiceContractIcon

const S = {
  Image: styled.img.withConfig({
    shouldForwardProp: (prop) => !['displayIcon'].includes(prop)
  })<{displayIcon: boolean}>`
    margin: 0px 4px;
    width: 24px;
    height: 24px;
    display:  ${({ displayIcon }) => displayIcon ? 'block' : 'none'};
    transition: all .2s ease;
  `
}
